module.exports = "<button data-playback-rate-button>\n  <%= title %>\n</button>\n<ul>\n  <% for (var i = 0; i < playbackRates.length; i++) { %>\n    <li><a href=\"#\" data-playback-rate-select=\"<%= playbackRates[i].value %>\"><%= playbackRates[i].label %></a></li>\n  <% }; %>\n</ul>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/public/playback-rate-selector.html
 ** module id = 2
 ** module chunks = 0
 **/